import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { bufferCount } from 'rxjs/operators/bufferCount';
import { concatMap } from 'rxjs/operators/concatMap';
import { from } from 'rxjs/observable/from';
export function probinator(hashedBlob$, _ref) {
  var batchSize = _ref.batchSize,
      prober = _ref.prober;
  return hashedBlob$.pipe(bufferCount(batchSize), concatMap(function (hashedBlobs) {
    return prober(hashedBlobs).then(function (probes) {
      return hashedBlobs.map(function (hashedBlob, index) {
        return _objectSpread(_objectSpread({}, hashedBlob), {}, {
          exists: probes[index]
        });
      });
    });
  }), concatMap(function (probedBlobs) {
    return from(probedBlobs);
  }));
}